import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GlassCard } from '../../components';
import './PolicyScreen.css';

export const TermsScreen = () => {
    const navigate = useNavigate();

    return (
        <div className="policy-screen">
            <div className="screen-header">
                <button className="back-btn" onClick={() => navigate(-1)}>
                    <span className="material-icons">arrow_back</span>
                </button>
                <h1 className="screen-title">Terms of Service</h1>
                <div style={{ width: 40 }}></div>
            </div>

            <div className="policy-content">
                <p className="last-updated">Last Updated: January 2026</p>

                <GlassCard className="policy-card">
                    <h2>1. Acceptance of Terms</h2>
                    <p>
                        By accessing and using the NEXTRON platform ("Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our Service.
                    </p>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>2. Eligibility</h2>
                    <p>
                        You must be at least 18 years of age to use this Service. By using the Service, you represent and warrant that you are at least 18 years old and have the legal capacity to enter into these Terms.
                    </p>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>3. Account Registration</h2>
                    <p>
                        To access certain features of the Service, you must register for an account. You agree to:
                    </p>
                    <ul>
                        <li>Provide accurate, current, and complete information</li>
                        <li>Maintain and update your information to keep it accurate</li>
                        <li>Maintain the security of your account credentials</li>
                        <li>Accept responsibility for all activities under your account</li>
                        <li>Notify us immediately of any unauthorized use</li>
                    </ul>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>4. Investment Products</h2>
                    <p>
                        Our platform offers various investment products with different return rates and durations. You acknowledge that:
                    </p>
                    <ul>
                        <li>All investments carry inherent risks</li>
                        <li>Past performance does not guarantee future results</li>
                        <li>You are solely responsible for your investment decisions</li>
                        <li>Returns are subject to market conditions and platform policies</li>
                    </ul>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>5. Deposits and Withdrawals</h2>
                    <p>
                        Users can deposit and withdraw funds subject to the following conditions:
                    </p>
                    <ul>
                        <li>Minimum deposit amount: ₹680</li>
                        <li>Minimum withdrawal amount: ₹120</li>
                        <li>Withdrawal processing time: 24-72 hours</li>
                        <li>Withdrawal tax: 8% of the withdrawal amount</li>
                        <li>Withdrawals are available Monday to Friday, 10 AM to 6 PM IST</li>
                    </ul>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>6. Referral Program</h2>
                    <p>
                        Our referral program allows you to earn bonuses by inviting new users. Referral bonuses are subject to:
                    </p>
                    <ul>
                        <li>Valid registration of referred users</li>
                        <li>Completion of KYC verification (if required)</li>
                        <li>Platform terms and conditions</li>
                    </ul>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>7. Prohibited Activities</h2>
                    <p>
                        You agree not to:
                    </p>
                    <ul>
                        <li>Use the Service for any illegal purpose</li>
                        <li>Attempt to gain unauthorized access</li>
                        <li>Interfere with the proper functioning of the Service</li>
                        <li>Create multiple accounts for fraudulent purposes</li>
                        <li>Engage in money laundering or fraudulent activities</li>
                    </ul>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>8. Termination</h2>
                    <p>
                        We reserve the right to suspend or terminate your account at any time for violation of these Terms or for any other reason at our discretion. Upon termination, your right to use the Service will immediately cease.
                    </p>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>9. Limitation of Liability</h2>
                    <p>
                        To the maximum extent permitted by law, NEXTRON shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the Service.
                    </p>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>10. Changes to Terms</h2>
                    <p>
                        We may modify these Terms at any time. We will notify users of significant changes via email or platform notification. Your continued use of the Service after changes constitutes acceptance of the new Terms.
                    </p>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>11. Contact Us</h2>
                    <p>
                        If you have any questions about these Terms, please contact us through our Support page or email us at support@nextron.com.
                    </p>
                </GlassCard>
            </div>
        </div>
    );
};

export default TermsScreen;
